<template>
  <div>
    <div v-if="!showAddTemplate">
      <el-button
        type="primary"
        style="margin-bottom:20px;"
        @click="showAddTemplateHandle">新建模板</el-button>
      <el-table
        :data="listData"
        width="80%"
        style="margin-bottom:100px;"
        border>
        <el-table-column
          v-for="item in columns()"
          :key="item.id"
          :label="item.label"
          :prop="item.prop"
        />
        <el-table-column
          label="操作"
          width="250px">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="small"
              @click="edit(scope.row.name,scope.row.id)">编辑</el-button>
            <el-button
              type="danger"
              size="small"
              @click="deleteTemplate(scope.row.id)">删除</el-button>
            <el-button
              icon="el-icon-search"
              type="small"
              size="small"
              @click="preview(scope.row.id)"
            >预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="showAddTemplate"
      :before-close="handleClose">
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="visibleContentHandler ">预览</el-button>
        <el-button @click="showAddTemplate = false">取 消</el-button>
        <el-button @click="save">保存</el-button>
      </span>
      <div class="edit">
        <div style="display:flex;align-items:center;margin-bottom:10px;">
          模板名称 :&nbsp;
          <el-input
            v-model="editParams.name"
            placeholder="请输入模板名称"
            style="width:30%" />
        </div>
        <div class="content_desc">
          <el-button
            size="small"
            style="margin-left: 10px;margin-bottom: 10px;"
            @click="fileReviewEdit('video')"
          >插入视频</el-button>
          <AppTextArea
            v-if="showAddTemplate"
            ref="editor"
            :value="editParams.content"
            :is-disable="false"
            :init-visible="true"
            style="font-weight: bold;"
            @change="changeFn"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible="visible.review"
      :show-close="false"
      :title="visible.title"
      top="5vh">
      <FileReview
        v-if="visible.review"
        :id="visible.name"
        @success="reviewUpdate"
        @cancel="reviewCancel"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="visibleContent"
      center>
      <div class="preview">
        <div v-html="previewContent" />
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="visibleContent = false">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mapUtils, { $form, $http, axiosRequest, baseURISaas } from "@/utils";
import FileReview from "./FileReview.vue";

export default {
  name: "TemplateManage",
  components: {
    FileReview,
  },
  data() {
    return {
      listData: [],
      showAddTemplate: false,
      title: "",
      showEdit: false,
      // 新增,编辑的表单收集字段
      editParams: {
        // id: this.$route.query.id,
        name: "",
        content: "",
      },
      // 显示预览
      visibleContent: false,
      previewContent: "",
      query: {
        page: 1,
        per_page: 100,
      },
      visible: {
        review: false,
        title: "",
        name: "",
      },
    };
  },
  mounted() {
    this.getTemplateList();
  },
  methods: {
    columns() {
      const data = [
        { label: "序号", prop: "id" },
        { label: "标题", prop: "name" },
        { label: "责任编辑", prop: "user_name" },
        { label: "更新时间", prop: "updated_at" },
      ];
      return data;
    },
    // json转 var='edit'字符串
    jsonToEqualString(json) {
      const keys = Object.keys(json);
      console.log(keys);
      const values = Object.values(json);
      console.log(values);
      let valueString = "";
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index];
        valueString += `${keys[index]}=${json[keys[index]]}&`;
      }
      console.log(valueString);
      return valueString;
    },
    getTemplateList() {
      const paramsString = this.jsonToEqualString(this.query);
      axiosRequest
        .get(`/content_template?${paramsString}`, {})
        .then((data) => {
          this.listData = data.data;
        })
        .catch((error) => {
          console.log("false");
        });
    },
    showAddTemplateHandle() {
      this.showAddTemplate = true;
      this.editParams = {
        name: "",
        content: "",
      };
      // 强制渲染富文本组件
    },
    addTemplate() {
      const params = {
        title: this.title,
      };
      axiosRequest
        .post("/content_template", params)
        .then((data) => {
          console.log("success", data);
        })
        .catch((error) => {
          console.log("false");
        });
    },
    deleteTemplate(id) {
      this.$confirm("是否删除模板？").then(() => {
        axiosRequest
          .delete(`/content_template/${id}`)
          .then(() => {
            console.log("删除成功!");
            this.$message.success("删除成功!");
            this.getTemplateList();
          })
          .catch(() => {});
      });
    },
    edit(name, id) {
      this.showEdit = true;
      this.editParams.name = name;
      this.editParams.id = id;
      axiosRequest
        .get(`/content_template/${id}`)
        .then((res) => {
          // this.editParams.content = res.content;
          this.$nextTick(() => {
            this.editParams = { ...res };
          });
          this.showAddTemplate = true;
        })
        .catch(() => {});
    },
    preview(id) {
      axiosRequest
        .get(`/content_template/${id}`)
        .then((res) => {
          this.previewContent = res.content;
          this.visibleContent = true;
        })
        .catch(() => {});
    },
    visibleContentHandler() {
      this.previewContent = this.editParams.content;
      this.visibleContent = true;
    },
    changeFn(data) {
      this.editParams.content = data;
      this.previewContent = data;
      console.log(data);
    },

    // 保存编辑内容和标题
    save() {
      if (this.editParams.name && this.editParams.content) {
        if (this.editParams.id) {
          axiosRequest
            .put(`/content_template/${this.editParams.id}`, this.editParams)
            .then((res) => {
              this.$message.success("保存成功!");
              delete this.editParams.id;
              this.showAddTemplate = false;
              this.getTemplateList();
            })
            .catch(() => {});
        } else {
          axiosRequest
            .post("/content_template", this.editParams)
            .then((res) => {
              this.$message.success("保存成功!");
              this.showAddTemplate = false;
              this.getTemplateList();
            })
            .catch(() => {});
        }
      } else {
        this.$message.error("模板名称和内容不能为空!");
      }
    },

    fileReviewEdit(name) {
      this.visible.review = true;
      this.visible.title = name === "file" ? "添加附件" : "插入视频";
      this.visible.name = name;
    },
    reviewCancel() {
      this.visible.review = false;
    },
    reviewUpdate(file, id) {
      switch (id) {
        case "file":
          this.fileUrl = file;
          this.$axios({
            method: "post",
            url: `${baseURISaas}/Tutor/saveTutorFileUrl`,
            data: {
              structure_id: this.$route.query.id,
              file_url: file,
            },
          })
            .then((res) => {
              console.log(res.data.code);
              if (res.data.code === 1) {
                this.$alert("附件保存成功！", "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {});
          break;
        case "video":
          this.$refs.editor.addVideo(file);
      }
      this.visible.review = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style>
.preview {
  width: 375px;
  margin: 0 auto;
  height: 667px;
  /* background: rgba(0, 0, 0, 0.4); */
  border: 2px solid black;
  overflow: scroll;
}
</style>
